module.exports = __webpack_public_path__ + "img/img11.0ff5e296.jpg";